/** @type {import("@/src/@types/SiteConfig").ISiteConfig} */
const siteConfig = {
    id: "canada",
    name: "Spot Pet Insurance Canada",
    // Page titles get " | Spot Pet Insurance", as on the US site: 21 characters, leaving 49 for the title within Semrush's 70.
    // (ENG-16339 turned the suffix off when it was the 28-character " | Spot Pet Insurance Canada".)
    titleBrandName: "Spot Pet Insurance",
    homeTitle: "Pet Insurance: Best In Breed Coverage",
    description:
        "Spot Pet Insurance is committed to helping dogs and cats live longer, healthier lives, by providing accident, illness & preventive care pet plans. Get a free quote.",
    homeSchemaDescription: "Spot Pet Insurance provides customizable pet insurance plans for dogs and cats across Canada.",
    homeSchemaTitle: "Pet Insurance for Dogs & Cats",
    twitterHandle: "@getspotcovered",
    i18n: {
        locales: ["en-CA"],
        defaultLocale: "en-CA"
    },
    quoteUnderwriter: "ptz-ca",
    publicSettingsOverride: {
        DATADOG_SITE_NAME: "spot-ca-website",
        QUOTE_FORM_URL_ROOT: process.env.NEXT_PUBLIC_QUOTE_FORM_URL_ROOT || "https://dev-quote.spotpetinsurance.ca",
        MEMBER_CENTER_URL_ROOT: process.env.NEXT_PUBLIC_MEMBER_CENTER_URL_ROOT || "https://members.spotpetinsurance.ca/",
        CS_PHONE_NUMBER: process.env.NEXT_PUBLIC_CS_PHONE_NUMBER || "888-501-7768",
        CS_PHONE_NUMBER_DISPLAY: process.env.NEXT_PUBLIC_CS_PHONE_NUMBER_DISPLAY || "888-501-7768",
        CS_EMPLOYER_PHONE_NUMBER: process.env.NEXT_PUBLIC_CS_EMPLOYER_PHONE_NUMBER || "888-501-7768",
        COOKIE_DOMAIN: process.env.NEXT_PUBLIC_COOKIE_DOMAIN || ".spotpetinsurance.ca",
        // GA4 is a US-scoped rollout for now; blank disables the gtag.js block in
        // _document.tsx so CA traffic never reports into the US GA4 property.
        GA4_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || ""
    },
    underwritingLink: "/underwriting",
    alternateLanguageSites: [{ origin: "https://spotpet.com", locales: ["en-US"], country: "United States" }],
    streetAddress: "710 Dorval Dr Unit # 401",
    addressLocality: "Oakville",
    addressRegion: "ON",
    postalCode: "L6K 3V7",
    countryCode: "CA",
    languageCode: "en",
    country: "Canada",
    currency: "CAD",
    referralProgram: true,
    samplePolicyLink: "https://spotpetinsurance.ca/sample-policy",
    productionUrl: "https://spotpetinsurance.ca",
    // TODO: remove or refactor this into an array of objects that can be used in the <Socials /> component
    socials: {
        instagram: "https://www.instagram.com/getspotcovered",
        facebook: "https://www.facebook.com/getspotcovered",
        linkedin: "https://www.linkedin.com/company/spot-pet-insurance/",
        tiktok: "https://www.tiktok.com/@getspotcovered?lang=en",
        twitter: "https://twitter.com/getspotcovered",
        youtube: "https://www.youtube.com/channel/SpotPetInsurance"
    },
    trustPilot: {
        apiKey: "eA7U1uIImvGVOGyAA3qc4NxgR9BnReTr",
        businessUnitId: "66d0bfb3f3f7fe4eab392793",
        url: "https://www.trustpilot.com/review/spotpetinsurance.ca?stars=4&stars=5"
    },
    useEmailForValidation: true,
    validationMessages: {
        labelText: {
            default: "Enter your Email Address",
            accountAccessPreferred: "Enter your Email Address"
        },
        errorText: {
            default: "Please check your Email Address",
            accountAccessPreferred: "Please check your Email Address"
        }
    },
    quoteIdCookieKey: "quoteIdPtzCa",
    quoteAttributesCookieKey: "quoteAttributesPtzCa",
    canShowQuoteWidget: false
};

module.exports = siteConfig;
